/** Height of the floating bottom nav pill (matches `mobileNavGlassSx`). */
export const MOBILE_NAV_HEIGHT = 80;

/** Gap between the bottom nav and the viewport edge (before safe-area). */
export const MOBILE_NAV_BOTTOM_GAP = 10;

/** iOS / notched-device safe-area env() values (0px when unsupported). */
export const SAFE_AREA_TOP = 'env(safe-area-inset-top, 0px)';
export const SAFE_AREA_BOTTOM = 'env(safe-area-inset-bottom, 0px)';

/** Distance from the physical screen bottom to the nav pill. */
export const MOBILE_NAV_BOTTOM = `calc(${MOBILE_NAV_BOTTOM_GAP}px + ${SAFE_AREA_BOTTOM})`;

/**
 * Clearance for the fixed floating bottom nav (pill + gap + home indicator).
 * Apply as scroll/content padding so pages can scroll out from under the overlay —
 * never as layout height reservation on the app shell (that would shrink the app).
 */
export const MOBILE_BOTTOM_NAV_INSET = `calc(${MOBILE_NAV_HEIGHT + MOBILE_NAV_BOTTOM_GAP}px + ${SAFE_AREA_BOTTOM})`;

/** Extra scroll padding for table/grid pages inside the main scroll area. */
export const MOBILE_CONTENT_BOTTOM_PADDING = 48;
